module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "col",
    attrs: {
      "id": "nav"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header_title"
  }, [_vm._v("江西聚小宝科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('ul', _vm._l((_vm.navItems), function(item) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          return _vm.addClass(item.link, $event)
        },
        "mouseleave": function($event) {
          return _vm.rmClass(item.link, $event)
        },
        "click": function($event) {
          return _vm.toLink(item.link, $event)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fec68a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 23
// module chunks = 0